import { render, staticRenderFns } from "./UserSubscriberBadge.vue?vue&type=template&id=df9e89dc&scoped=true&"
import script from "./UserSubscriberBadge.vue?vue&type=script&lang=ts&"
export * from "./UserSubscriberBadge.vue?vue&type=script&lang=ts&"
import style0 from "./UserSubscriberBadge.vue?vue&type=style&index=0&id=df9e89dc&lang=scss&scoped=true&"
import style1 from "./UserSubscriberBadge.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9e89dc",
  null
  
)

export default component.exports